import React, {useState, useRef, useEffect, useContext} from 'react';
import styled from 'styled-components';
import {Upload, message, Modal} from 'antd';
import MultipartUploader from './MultipartUploader';
import {Check, Close} from '@styled-icons/material';
import {UploadCloud, AlertCircle} from '@styled-icons/feather';
import {Context} from '../AppContext';
import {ErrUploadFile} from '../errors';

import UploadProgress, {metadata} from '../Modals/UploadProgress';
const appConfig = require('../data.json');

const Button = styled.div`
  cursor: pointer;
  background-color: ${(props) =>
    props.status === 'rejected'
      ? '#FCE2E5'
      : props.status === 'waiting'
      ? '#eee'
      : appConfig.colors.main};
  color: ${(props) =>
    props.status === 'rejected'
      ? appConfig.colors.text
      : props.status === 'waiting'
      ? '#999'
      : 'white'};
  padding: 6px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  min-width: 120px;

  :hover {
    opacity: 0.75;
  }
`;

const STEPS = {
  GET_JWT: 0,
  PREPARE: 1,
  UPLOAD: 2,
  UPDATE_ITEM: 3,
};

const INIT_STATE = {
  loading: false,
  step: STEPS.GET_JWT,
  percentage: 0,
  url: '',
};

export default function UploadAttachmentButton(props) {
  const [step, setStep] = useState(INIT_STATE.step);
  const [percentage, setPercentage] = useState(INIT_STATE.percentage);
  const [openDialog, setOpenDialog] = useState(false);
  const url = useRef(INIT_STATE.url);
  const uploader = useRef();
  const app = useContext(Context);
  const {onUpdate, orderItem} = props;
  const status = orderItem?.status;

  useEffect(() => {
    uploader.current = new MultipartUploader({
      host: appConfig.endpoint.revStorageHost,
      debug: appConfig.debug,
      onProgress: (percentage) => setPercentage(percentage),
      onStart: () => setStep(STEPS.UPLOAD),
      onComplete: ({url: _url}) => {
        url.current = _url;
      },
    });

    return () => uploader.current.close();
  }, []);

  const addAttatchment = (url) => {
    return app.actions.addAttatchment({
      order: orderItem.order,
      item_index: orderItem.item_index,
      url,
    });
  };

  const reset = () => {
    uploader.current.reset();
    setStep(INIT_STATE.step);
    setPercentage(INIT_STATE.percentage);
    url.current = INIT_STATE.url;
    setOpenDialog(false);
    app.actions.setLoading(false);
  };

  const upload = async (info) => {
    try {
      let file = info.file; //.originFileObj; // put antd file into uppy would throw error

      // step 1: get JWT token
      app.actions.setLoading(true);
      setOpenDialog(true);
      let {token} = await app.actions.getJwtToken();
      uploader.current.setToken(token);

      // step 2 add file to uppy
      setStep(STEPS.PREPARE);

      let result = await uploader.current.upload(file);
      console.log('RETURN FROM UPLOAD', result);

      if (result) {
        if (result.successful) {
          // multi part upload success
        } else {
          throw new ErrUploadFile('上傳失敗');
        }

        // step 4: update order_item attachment
        setStep(STEPS.UPDATE_ITEM);
        await addAttatchment(url.current);

        message.success('上傳成功');
        onUpdate();
      }
    } catch (err) {
      console.warn(err);
      message.error('上傳失敗');
    }

    reset();
  };

  return (
    <div>
      <Upload
        fileList={[]}
        name="file"
        beforeUpload={(file) => false}
        onChange={upload}>
        {status === 'rejected' ? (
          <Button status={status}>
            <AlertCircle size="26" color={appConfig.colors.warning} />
            <span style={{marginLeft: 5}}> 重上傳檔案</span>
          </Button>
        ) : status === 'waiting' ? (
          <Button status={status}>
            <UploadCloud size="26" color="#999" />
            <span style={{marginLeft: 5}}> 上傳檔案</span>
          </Button>
        ) : (
          <Button status={status}>
            <Check size="26" color="white" />
            <span style={{marginLeft: 5}}> 已上傳檔案</span>
          </Button>
        )}
      </Upload>

      <Modal
        visible={openDialog}
        onCancel={reset}
        title={metadata.title}
        footer={false}
        closeIcon={
          <Close
            style={{position: 'absolute', right: 20, top: 20}}
            size={20}
            color="#000"
          />
        }
        width={metadata.width}>
        <UploadProgress percentage={percentage} step={step} />
      </Modal>
    </div>
  );
}
